/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_To_IconikInputs */



/**
* | output |
* | --- |
* | "Publish work to Iconik" |
*
* @param {Publish_To_IconikInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const publish_to_iconik = /** @type {((inputs?: Publish_To_IconikInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_To_IconikInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publier sur Iconik")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichen Sie Ihre Arbeit auf Iconik")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblica il lavoro su Iconik")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Опубликовать работу в Iconik")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicar trabajo en Iconik")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将作品发布到 Iconik")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Iconikに作品を公開する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Iconik पर अपना काम प्रकाशित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publique seu trabalho na Iconik.")
	return /** @type {LocalizedString} */ ("Publish work to Iconik")
});